import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Icon, P, Stack, Tooltip } from '@fashionnovateam/nova-ui-toolkit';
import { ItemLeadTimeFormValues } from '../../types';
import { ControlledFormInput } from '../../../../Lib/Utils/FormUtils/ControlledFormInput';
import { FormSection } from '../components/FormSection';
import { STOCK_IHD_TOOLTIP } from '../../../../Lib/Constants/ui-text';

type StockDetailsSectionProps = {
  disabled?: boolean;
};

export function StockDetailsSection({ disabled }: StockDetailsSectionProps) {
  const { control } = useFormContext<ItemLeadTimeFormValues>();

  return (
    <FormSection
      icon="package/package-02"
      title="Stock Details"
      gradientFrom="from-[#F8F8F8]"
      gradientTo="to-white"
      bgColor="bg-white"
    >
      <Stack direction="row" gap="md">
        <ControlledFormInput
          control={control}
          name="stock_quantity"
          label="Stock Qty"
          inputType="number"
          disabled={disabled}
          inputProps={{
            className: 'w-full',
            min: '0',
            endAdornment: (
              <P size="xs" color="disabled">
                units
              </P>
            ),
          }}
        />
        <ControlledFormInput
          control={control}
          name="stock_ratio"
          label="Stock Ratio"
          inputType="text"
          disabled={disabled}
          inputProps={{
            className: 'w-full',
            placeholder: '0-0-0',
          }}
        />
        <div className="w-full">
          <div className="flex items-center gap-1 mb-1">
            <P size="sm" weight="medium" className="text-base-primary">
              Stock IHD
            </P>
            <Tooltip
              content={STOCK_IHD_TOOLTIP}
              position="top"
              arrow
              zIndex={60}
            >
              <Icon.InformationCircle className="text-neutral-400 cursor-help text-sm flex-shrink-0" />
            </Tooltip>
          </div>
          <ControlledFormInput
            control={control}
            name="earliest_IHD_date_to_deliver_stock"
            label=""
            inputType="date"
            disabled={disabled}
            inputProps={{ className: 'w-full' }}
          />
        </div>
      </Stack>

      <Stack direction="row" gap="md">
        <ControlledFormInput
          control={control}
          name="incoming_stock_quantity"
          label="Incoming Stock Qty"
          inputType="number"
          disabled={disabled}
          inputProps={{
            className: 'w-full',
            min: '0',
            endAdornment: (
              <P size="xs" color="disabled">
                units
              </P>
            ),
          }}
        />
        <ControlledFormInput
          control={control}
          name="incoming_stock_ratio"
          label="Incoming Stock Ratio"
          inputType="text"
          disabled={disabled}
          inputProps={{
            className: 'w-full',
            placeholder: '0-0-0',
          }}
        />
        <ControlledFormInput
          control={control}
          name="incoming_stock_date"
          label="Incoming Stock IHD"
          inputType="date"
          disabled={disabled}
          inputProps={{ className: 'w-full' }}
        />
      </Stack>
    </FormSection>
  );
}
